import { render, staticRenderFns } from "./rfa-batches.vue?vue&type=template&id=1501aac4"
import script from "./rfa-batches.vue?vue&type=script&lang=js"
export * from "./rfa-batches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports